// extracted by mini-css-extract-plugin
export default {"header__quote":"quotes_header__quote__pluEO"};